import { color } from '@tokens';

export type NotificationKind = 'info' | 'danger' | 'success' | 'warning';

export type ToastKind = Exclude<NotificationKind, 'warning'>;

export const BACKGROUND_COLORS: { [key: string]: string } = {
  info: color.bg_info,
  danger: color.bg_danger,
  success: color.bg_success,
  warning: color.bg_warning,
};

export const BORDER_COLORS: { [key: string]: string } = {
  info: color.ui_border,
  danger: color.ui_border_danger,
  success: color.ui_border_success,
  warning: color.ui_border_warning,
};
